import { React, useState } from 'react'
import styled from 'styled-components'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from "dayjs";

function DatePickerEvent({
    date,
    setDate,
    checkboxState,
    setCheckBoxState
}) {

    const handleDatePickerActivity = (e) => {
        //setEnableDate(!e.target.checked)
        setCheckBoxState(e.target.checked)
        if(!e.target.checked){
            setDate(dayjs())
        }
    }

    //const [enableDate, setEnableDate] = useState(true);
    return (
        <Container>
            <input type="checkbox" onChange={handleDatePickerActivity} checked={checkboxState}/>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker 
                    label="Fecha de consumo"
                    format="YYYY/MM/DD" 
                    disabled={!checkboxState} 
                    slotProps={{
                        textField: {
                            size: "small"
                        }
                    }} 
                    value={date}
                    onChange={(newDate)=>{setDate(newDate)}}
                    minDate={dayjs("2026-09-01")}
                    maxDate={dayjs()}
                />
            </LocalizationProvider>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;    
`

export default DatePickerEvent